import { render, staticRenderFns } from "./AlertAssignModal.vue?vue&type=template&id=18d72b12&scoped=true"
import script from "./AlertAssignModal.vue?vue&type=script&lang=js"
export * from "./AlertAssignModal.vue?vue&type=script&lang=js"
import style0 from "./AlertAssignModal.vue?vue&type=style&index=0&id=18d72b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d72b12",
  null
  
)

export default component.exports